import request from '../../utils/request';

// #149 — Monitoring → Integrity. Violations of the order state machine and of
// the route-step invariants, recorded by the backend (INTEGRITY_MODE=report)
// and by the nightly sweep.
export function getIntegrityViolations(params) {
  return request('/integrity/violations', { method: 'GET', params });
}

export function getIntegrityViolationCount() {
  return request('/integrity/violations/count', { method: 'GET' });
}

export function resolveIntegrityViolation(id) {
  return request(`/integrity/violations/${id}/resolve`, { method: 'POST' });
}

// Evaluate routes now; `persist` records what is found and resolves what is gone.
export function runIntegritySweep(data) {
  return request('/integrity/sweep', { method: 'POST', data });
}
